<!-- apps/frontend/src/components/flow/nodes/FetchHistoryNode.vue -->
<template>
  <div :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible',
                selected ? 'border-purple-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']">
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-purple-400">history</span>
        <strong class="text-white text-sm">{{ $t('flowEditor.palette.fetchHistory') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    <div class="p-3">
      <p class="text-gray-400 text-xs truncate">
        <span class="text-purple-300 font-mono">{{ data.targetVariable || 'history' }}</span>
        <span class="text-gray-500"> ← {{ $t('flowEditor.fetchHistoryEditor.lastN', { n: data.limit || 100 }) }}</span>
      </p>
    </div>
    <Handle type="target" :position="Position.Left" />
    <Handle type="source" :position="Position.Right" />
    <AddNodeButton v-if="!hasOutgoingEdge" accent="purple" @add="emit('add-node', nodeId)" />
  </div>
</template>
<script setup>
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';
const emit = defineEmits(['add-node']);
defineProps({
  data:            { type: Object,  required: true },
  selected:        { type: Boolean, default: false },
  nodeId:          { type: String,  required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});
</script>
